export const getPDFPagesFromFile = file =>
  new Promise((resolve) => {
    window.pdfjsDistBuildPdf.getDocument(file).promise.then((doc) => {
      const pages = [];
      const currentDocPages = [];

      while (pages.length < doc.numPages) pages.push(pages.length + 1);

      return Promise.all(pages.map(num => doc.getPage(num)
        .then(page => currentDocPages.push({ page, file }))
        .then(() => {
          if (currentDocPages.length === doc.numPages) {
            currentDocPages.sort((a, b) =>
              parseInt(a.page.pageIndex, 10) - parseInt(b.page.pageIndex, 10),
            );
            resolve(currentDocPages);
          }
        })),
      );
    });
  });

export const assignIDsToPages = (pageObjects) => {
  const pageObjsWithIds = pageObjects;
  return new Promise((resolve) => {
    for (let i = 0; i < pageObjsWithIds.length; i += 1) {
      pageObjsWithIds[i].id = i;
    }
    resolve(pageObjsWithIds);
  });
};



// WEBPACK FOOTER //
// ./src-react/PDFUtils/index.jsx